let actionEdit = function(id) {
	this.$router.push({
		name: "InvoiceEdit",
		params: { idinv: id},
	});
};
export default actionEdit;
